export default "__VITE_ASSET__kM1$4_8U__";